import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'htmlToPlaintext'})
export class HtmlToPlaintextPipe implements PipeTransform
{
    /**
     * Transform
     *
     * @param {string} value
     * @param {any[]} args
     * @returns {string}
     */
    transform(value: string, args: any[] = []): string
    {
        // Regex otimizado para evitar ReDoS: usa quantificador não-guloso
        return value ? String(value).replace(/<[^>]*?>/g, '') : '';
    }
}
